const message = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%202a2%202%200%200%201%202%202v12a2%202%200%200%201-2%202h-7.913L6%2021.804V18H4a2%202%200%200%201-2-2V4a2%202%200%200%201%202-2h16zm0%202H4v12h4v2.196L11.513%2016H20V4zm-6%207v2H7v-2h7zm2-4v2H7V7h9z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  message as default
};
//# sourceMappingURL=message.svg.es.js.map
